import { Injectable } from "@angular/core";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { BaseEntityService } from "./rest-common.service";
import { map } from "rxjs/operators";
import { NotificationService } from "src/app/notification.service";

@Injectable({
  providedIn: "root",
})
export class GeoService extends BaseEntityService {
  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  getCountries(
    searchFields: String = "",
    searchValues: String = "",
    exclude: String = "",
    start_element: number = 0,
    num_elements: number = 100,
  ) {
    return this.get(
      `${this.BASE_API_URL}/country/?fields=name,id,code&${searchFields}${searchValues}${exclude}&start_element=${start_element}&num_elements=${num_elements}`
    );
  }

  getGeo(type: 'country' | 'region' | 'city' | 'dma', start_element: number = 0, num_elements: number = 300, params = {}) {
    if (type == 'country') params['fields'] = 'name,id,code'
    if (type == 'region') params['fields'] = 'id,name,country_name,country_id'
    if (type == 'city') params['fields'] = 'id,name,country_name,region_name,country_id,region_id'
    params['start_element'] = start_element
    params['num_elements'] = num_elements
    let url = this.buildUrl(`${this.BASE_API_URL}/${type}/`, '', params)
    return this.get(url);
  }


  getCities(
    searchFields: String = "",
    searchValues: String = "",
    excludes: String = "",
    start_element: number = 0,
    num_elements: number = 100,
  ) {
    return this.get(
      `${this.BASE_API_URL}/city/?fields=id,name,country_name,region_name,country_id,region_id${searchFields}${searchValues}${excludes}&start_element=${start_element}&num_elements=${num_elements}`
    );
  }

  // "search_fields=id",`&id=${item.value.join()}`,""

  getRegions(
    searchFields: String = "",
    searchValues: String = "",
    exclude: String = "",
    start_element: number = 0,
    num_elements: number = 100,
  ) {
    return this.get(
      `${this.BASE_API_URL}/region/?fields=id,name,country_name,country_id${searchFields}${searchValues}${exclude}&start_element=${start_element}&num_elements=${num_elements}`
    );
  }

  getDmas(
    searchFields: String = "",
    searchValues: String = "",
    exclude: String = ""
  ) {
    return this.get(
      `${this.BASE_API_URL}/dma/?fields=name,id&${searchFields}${searchValues}${exclude}`
    );
  }

  getPostalCodes(
    searchFields: String = "",
    searchValues: String = "",
    exclude: String = ""
  ) {
    return this.get(
      `${this.BASE_API_URL}/postal-code/?fields=id,code&${searchFields}${searchValues}${exclude}`
    );
  }

  getCll(params) {
    return this.get(this.buildUrl(`${this.BASE_API_URL}/custom-location-list`, '', params))
  }

  getGeoGlobalSearchResult(search, fields = null, search_field = 'name') {
    let params = {
      'search_fields': search_field,
      'name': search,
    }
    if (fields) params['fields'] = fields //'id,name'
    return this.get(this.buildUrl(`${this.BASE_API_URL}/geo/`, '', params))
  }

  validatePostalCodes(data) {
    let url = `${this.BASE_API_URL}/postal-code-validate/`;
    return this.post(url, data);
  }

  getGeoData(data, params = {}) {
    let url = this.buildUrl(`${this.BASE_API_URL}/geo/data/`, '', params)
    return this.post(url, data);
  }

  getSystemData(data, params = {}) {
    let url = this.buildUrl(`${this.BASE_API_URL}/systems/data/`, '', params)
    return this.post(url, data);
  }
}
